export const getAblEnforcementDialogStyle = () => ({
  dialogBackground: {
    overflow: 'auto',
    overflowY: 'scroll',
    position: 'fixed',
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1070,
  },
  dialog: {
    position: 'absolute',
    backgroundColor: '#FFFFFF',
    transform: 'translate(-50%, -50%)',
    top: '50%',
    left: '50%',
    boxShadow: '0px 4.8px 14.4px rgba(0, 0, 0, 0.18), 0px 25.6px 57.6px rgba(0, 0, 0, 0.22)',
    borderRadius: '2px',
    maxWidth: 600,
    overflow: 'auto',
  },
});

export const getAblEnforcementFormStyle = () => ({
  lightboxContainer: {
    minWidth: 350,
    border: '2px solid #CCC',

    '&& .lightbox-title': {
      fontSize: 20,
      fontWeight: 600,
    },
    '& .btn + .btn': {
      marginLeft: 8,
    },
  },
  lightboxHeader: {
    padding: '15px 24px 15px 24px',
  },
  lightboxBody: {
    position: 'relative',
    padding: '0 24px 0 24px',
  },
  ablSuggestions: {
    paddingLeft: 20,
  },
  suggestionList: {
    paddingTop: 10,
  },
  lightboxMainMessage: {
    marginBottom: 10,
    marginTop: 10,
  },
  lightboxMidContent: {
    marginBottom: 10,
  },
  lightboxSubMessage: {
    marginBottom: 5,
  },
  lightboxFooter: {
    padding: '19px 20px 20px',
  },
});

